import React from 'react'
import { useNavigate } from 'react-router-dom'

const TabLiveChat = ({ tabs, setTabName, tabName, count, pathName }) => {
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const getCount = (num) => {
    if (num === 0) {
      return count?.assigned_count
    } else if (num === 1) {
      return count?.unassigned_count
    } else {
      return count?.all_count
    }
  }
  
  function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }
  return (
    <div className='w-[45%] max-sm:w-full'>
      <div className="">
        <div>
          <nav className="-mb-px flex sm:space-x-2" aria-label="Tabs">
            {tabs.map((tab, t_ind) => (
              <div
                key={tab.name}
                // href={tab.href}
                onClick={() => {
                  setTabName(tab.name);
                  const newUrl = `/livechat/${pathName}/${tab?.name?.toLowerCase()}?${params.toString()}`;
                  navigate(newUrl);
                }}
                className={classNames(
                  window?.location?.pathname?.includes(tab?.name?.toLowerCase()) 
                    ? 'border-[var(--brand-primary)] text-gray-900'
                    : 'border-transparent text-gray-600 hover:border-gray-300 hover:text-gray-700',
                  'not-italic flex gap-2 items-center leading-5 whitespace-nowrap max-sm:w-1/2 border-b-2 py-2 text-center px-1 text-sm font-medium cursor-pointer'
                )}
                aria-current={tab.current ? 'page' : undefined}
              >
                <span>{tab.name}</span> 
                <span className="inline-flex items-center rounded-md bg-gray-100 px-1 py-0 text-[10px] font-medium text-gray-600 ring-1 ring-inset ring-gray-800/10">
                  {getCount(t_ind)}
                </span>
              </div>
            ))}
          </nav>
        </div>
      </div>
    </div>
  )
}

export default TabLiveChat;